'use strict';
/* created by lilei 2017.10.30
 *代替ng-disabled 按钮 被禁止 的 提示说明
 */
angular.module('util.btnDisabled', []).
directive('btnDisabled', ['$timeout', '$compile', function($timeout, $compile) {
    return {
        restrict: 'C',
        scope: {
            ngDisabled: '='
        },
        link: function(scope, iElement, attrs) {
            var $disabledTipDiv;
            scope.$watch('ngDisabled', function() {
                iElement.removeAttr('disabled');
                $timeout(function() {
                    init();
                }, 500);
            });
            /**/
            /**
             * [myClick description] 点击事件
             * @return {[type]} [description]
             */
            scope.myClick = function($event) {
                if (scope.ngDisabled) {
                    $event.stopPropagation();
                }
            };
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                var disabled = attrs.disabled;
                var disabledTip;
                if (scope.ngDisabled) {
                    var buttonHeight = iElement[0].offsetHeight;
                    if (buttonHeight) {
                        var div = $compile('<div ng-show="ngDisabled===true" ng-click="myClick($event)" class="disabled"></div>')(scope);
                        iElement.append(div);
                        iElement.css({ "cursor": "pointer", "position": "relative" });
                        iElement.unbind("mouseenter").bind("mouseenter", function() {
                            if (!scope.ngDisabled) return;
                            buttonHeight = iElement[0].offsetHeight;
                            var buttonWidth = iElement[0].offsetWidth;
                            var buttonTop = iElement.offset().top;
                            var buttonLeft = iElement.offset().left;
                            disabledTip = !attrs['disabledTip'] ? '请先选择稿件' : attrs['disabledTip'];
                            $('body').append(["<div class='disabled-tip tip_" + scope.$id + "'>" + disabledTip + "</div>"].join(""));
                            $(".tip_" + scope.$id).show();
                            iElement.css({ "cursor": "pointer", "position": "relative" });
                            $disabledTipDiv = $(".tip_" + scope.$id);
                            var selfHeight = $disabledTipDiv[0].offsetHeight;
                            var selfWidth = $disabledTipDiv[0].offsetWidth;
                            $disabledTipDiv.css({
                                top: buttonTop - selfHeight - 10,
                                left: buttonLeft + (buttonWidth - selfWidth) / 2
                            });
                        }).unbind("mouseleave").bind("mouseleave", function() {
                            $(".tip_" + scope.$id).remove();
                        });
                    }
                }
            }
            scope.$on("$destroy", function() {
                $(".tip_" + scope.$id).remove();
            });
        }
    };
}]);